import { fetchSuccessPlanFilesV2 } from '../routines/successPlanRoutines';

const initialState = {
  files: {
    items: [],
    loading: true,
    isSuccess: false,
  },
};

const successPlanFilesReducerV2 = (state = initialState, action) => {
  switch (action.type) {
    case fetchSuccessPlanFilesV2.TRIGGER:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true,
          isSuccess: false,
        },
      };

    case fetchSuccessPlanFilesV2.SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          items: action.payload.data,
          loading: false,
          isSuccess: true,
        },
      };

    case fetchSuccessPlanFilesV2.FAILURE:
      return {
        ...state,
        files: {
          ...state.files,
          items: [],
          loading: false,
          isSuccess: false,
        },
      };
    default:
      return state;
  }
};

export default successPlanFilesReducerV2;
